(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["explosie"] && !Shopify.designMode) return;
  try {
    // Wie bewegend beeld liever uit heeft, krijgt het stilstaande beginbeeld.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.explosie__video').forEach((v) => {
      v.removeAttribute('autoplay');
      v.pause();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
